globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Account = appCustomerSpace.Modals.Account || {};

appCustomerSpace.Modals.Account.MissingInformation = (function(superClass) {

  utils.extend(MissingInformation, superClass);

  function MissingInformation() {
    return MissingInformation.__super__.constructor.apply(this, arguments);
  }

  $.extend(MissingInformation.prototype, {
    init: function() {
      this.initEvents();

      return MissingInformation.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data){
      var modal = this;

      if(!data.response) {
        appCustomerSpace.Loader().stop({$container: modal.$html.find('.modal-content')})
      } else {
        return MissingInformation.__super__.callbackSuccess.apply(this, arguments);
      }
    },
    initEvents: function(){
      var modal = this;
      modal.$html.find('.declare-having-an-administrative-id-form-group').on('click', "input[type='radio']", function() {
        var $radio = $(this);

        if ($radio.hasClass('radio-true')) {
          modal.$html.find('.administrative-id-form-group').show();
          modal.$html.find('.administrative-id-form-group input').focus();
        };
        if ($radio.hasClass('radio-false')) {
          modal.$html.find('.administrative-id-form-group').hide();
        };
      });
    }
  });

  return MissingInformation;

})(appCustomerSpace.Modal);
